import { useInlineStatusQuery } from "@octopusdeploy/octopus-react-client";
import type { TimelineItem } from "@octopusdeploy/octopus-server-client";

export type AvailableTimelineItemResponse = {
    items: TimelineItem[];
    currentItem: TimelineItem;
};

export function useTimelineItems(projectId: string, environmentId: string, executionId: string, tenantId?: string): [boolean, Error | undefined, AvailableTimelineItemResponse | undefined] {
    const { result: deploymentTimelineResponse, isLoading, error } = useInlineStatusQuery((repo) => repo.Deployments.getDeploymentTimeline(projectId, environmentId, tenantId), [environmentId, projectId, tenantId], "Load deployment timeline");

    const timelineItems = deploymentTimelineResponse?.TimelineItems.Items;
    const currentTimelineItem = timelineItems?.find((item) => item.Id === executionId);

    const primaryError = (error ?? (!isLoading && currentTimelineItem === undefined)) ? Error("Unable to determine a timeline element for the current deployment") : undefined;

    return [
        isLoading,
        primaryError,
        timelineItems && currentTimelineItem
            ? {
                  items: timelineItems,
                  currentItem: currentTimelineItem,
              }
            : undefined,
    ];
}
